export const DEFAULT_TRUNCATE_LENGTH  =25;

export const truncate = (text: string, length: number = DEFAULT_TRUNCATE_LENGTH): string => {
    if (text.length <= length) return text;

    return `${[...text].splice(0, length).join("")}...`;
};
